module.exports = __webpack_public_path__ + "img/contract-yellow.6e055f2f.svg";